import {Outlet, useParams} from "react-router-dom";

export default function Application() {

    let params = useParams();

    if (params.application != null && (params.application.toUpperCase() === 'K9' || params.application.toUpperCase() === 'WDA' || params.application.toUpperCase() === 'INSTALL')) {
        localStorage.setItem("REDIRECT_APP", params.application);
    }
    return (
        <div>
            <Outlet/>
        </div>
    )
}
